var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticClass:"pa-0",staticStyle:{"height":"552px","overflow-y":"auto"}},[_c('div',{staticClass:"pa-1",staticStyle:{"height":"auto"}},[_c('stats',{attrs:{"id":_vm.id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }